<template xmlns="">
  <div class="booking-container-light">
    <swiper ref="aliBeySwiper" :options="aliBeySwiperOptions" class="booking-swiper">
      <swiper-slide class="booking-slide">
        <div class="slide-content">
          <h2 class="slide-title">LOS GEHT'S! 🔥<br />Wer ist dabei?</h2>
          <v-form v-if="form.persons.length" ref="personForm" lazy-validation class="person-form">
            <v-row no-gutters>
              <v-col cols="12">
                <v-menu
                  ref="menu"
                  v-model="rangePicker"
                  :close-on-content-click="false"
                  :return-value.sync="bookingDateRange"
                  transition="scale-transition"
                  offset-y
                  min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formattedBookingDateRange"
                      label="Reisezeitraum"
                      prepend-icon="mdi-calendar-range"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined></v-text-field>
                  </template>
                  <v-date-picker locale="de-DE" min="2026-05-28" max="2026-06-13" no-title range v-model="bookingDateRange" color="primary">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="rangePicker = false">Abbrechen</v-btn>
                    <v-btn text color="primary" @click="$refs.menu.save(bookingDateRange)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <div class="person-cards-container">
              <v-card v-for="(person, index) in form.persons" :key="index" class="person-card" outlined>
                <v-card-title class="person-card-title">
                  <v-icon class="mr-2" color="primary">mdi-account-circle</v-icon>
                  Person {{ index + 1 }}
                  <v-spacer></v-spacer>
                  <v-btn v-if="form.persons.length > 1" @click="deletePerson(index)" icon small>
                    <v-icon color="grey">mdi-close-circle</v-icon>
                  </v-btn>
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="6"
                      ><v-text-field outlined dense v-model="person.firstName" :rules="requiredField" label="Vorname"></v-text-field
                    ></v-col>
                    <v-col cols="12" md="6"
                      ><v-text-field outlined dense v-model="person.lastName" :rules="requiredField" label="Nachname"></v-text-field
                    ></v-col>
                    <v-col cols="12" md="6">
                      <v-menu
                        :ref="'birthDayPicker' + index"
                        v-model="person.birthDayPicker.activeMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            outlined
                            dense
                            @click="setPickerToYear(index)"
                            v-model="person.birthDayPicker.date"
                            label="Geburtstag"
                            prepend-inner-icon="mdi-cake-variant"
                            readonly
                            :rules="requiredField"
                            v-bind="attrs"
                            v-on="on"></v-text-field>
                        </template>
                        <v-date-picker
                          color="primary"
                          locale="de-CH"
                          v-model="person.birthDayPicker.date"
                          :active-picker.sync="activeBirthDayPicker"
                          :max="new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10)"
                          min="1920-01-01"
                          @change="saveDatePicker($event, index)"></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" md="6"
                      ><v-select
                        outlined
                        dense
                        v-model="person.shirtSize"
                        :items="tshirtSizes"
                        label="T-Shirt Größe"
                        prepend-inner-icon="mdi-tshirt-crew"
                        :rules="requiredField"></v-select
                    ></v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </div>
            <v-btn class="add-person-btn" outlined color="primary" @click="addNewPerson"><v-icon left>mdi-plus</v-icon>Person hinzufügen</v-btn>
          </v-form>
          <v-card-actions class="slide-actions">
            <v-btn text color="primary" @click="exitAlibey()" large>Zurück</v-btn>
            <v-btn class="next-step-btn" color="primary" x-large rounded @click="slideToSelection">Angebote ansehen</v-btn>
          </v-card-actions>
        </div>
      </swiper-slide>

      <swiper-slide class="booking-slide">
        <div class="slide-content">
          <h2 class="slide-title">WÄHLE DEIN PARADIES 🌴</h2>
          <div class="room-selection-container" v-if="filteredRooms && filteredRooms.length > 0">
            <v-card
              v-for="(room, index) in filteredRooms"
              :key="index"
              class="room-card"
              :class="{ 'selected-glow': room.selected }"
              @click="selectRoom(index)"
              outlined>
              <v-img height="200px" :src="room.img"></v-img>
              <v-card-title class="room-title">{{ room.subtitle }} {{ room.title }}</v-card-title>
              <v-card-text class="room-price">
                <span class="price-total">{{ formatPrice(Math.round(room.possibility.price * duration + aerobicPrice * adultCount)) }} CHF</span>
                <span class="price-per-day">{{ Math.round(room.possibility.price + (aerobicPrice * adultCount) / duration) }} CHF / Tag</span>
                <span class="price-info">*zzgl. Flug</span>
              </v-card-text>
              <v-spacer></v-spacer>
              <v-expand-transition>
                <div v-show="room.showEquipment">
                  <v-divider></v-divider>
                  <div class="equipment-grid">
                    <v-chip v-for="(equipment, i) in room.equipment" :key="i" class="equipment-chip" small>
                      {{ equipment }}
                    </v-chip>
                  </div>
                </div>
              </v-expand-transition>
              <v-card-actions class="room-actions">
                <v-btn text color="primary" @click.stop="showEquipment(index)">
                  {{ room.showEquipment ? "Weniger" : "Mehr" }} Details
                  <v-icon right>{{ room.showEquipment ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </div>
          <div v-else class="no-results">
            <v-icon size="64" class="mb-4">mdi-magnify-remove-outline</v-icon>
            <p>Für diese Auswahl wurden leider keine Zimmer gefunden.</p>
          </div>
          <v-card-actions class="slide-actions">
            <v-btn text color="primary" @click="slideTo(0)" large>Zurück</v-btn>
            <v-btn class="next-step-btn" color="primary" x-large rounded :disabled="!selectedRoom" @click="confirmRoom">Auswahl bestätigen</v-btn>
          </v-card-actions>
        </div>
      </swiper-slide>

      <swiper-slide class="booking-slide">
        <div class="slide-content" v-if="selectedRoom">
          <h2 class="slide-title">FAST GESCHAFFT! 🚀</h2>
          <v-card class="confirmation-card" outlined>
            <v-img max-height="250px" :src="selectedRoom.img"></v-img>
            <v-card-title class="justify-center confirmation-title">{{ selectedRoom.subtitle }} {{ selectedRoom.title }}</v-card-title>
            <v-card-subtitle class="text-center">{{ duration }} Nächte für {{ form.persons.length }} Person(en)</v-card-subtitle>
            <v-divider class="mx-4"></v-divider>
            <v-card-text class="text-center price-summary">
              <div class="total-price-label">Gesamtpreis</div>
              <div class="total-price-value">
                {{ formatPrice(Math.round(selectedRoom.possibility.price * duration + aerobicPrice * adultCount)) }} CHF
              </div>
              <div class="price-info">*zzgl. Flugkosten</div>
            </v-card-text>
            <v-card-actions class="slide-actions confirmation-actions">
              <v-btn text color="primary" @click="slideTo(1)" large>Zurück</v-btn>
              <v-btn class="next-step-btn" color="primary" x-large rounded :loading="bookingLoading" @click="createBooking"
                >Definitiv Reservieren</v-btn
              >
            </v-card-actions>
          </v-card>
        </div>
      </swiper-slide>

      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    <v-snackbar color="error" v-model="showSnackBar" timeout="3000" centered>
      {{ snackBarMessage }}
    </v-snackbar>
  </div>
</template>

<script>
// ... (DEIN GESAMTER SCRIPT-BEREICH BLEIBT UNVERÄNDERT)
import api from "../../api"
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper"
import { mapState, mapActions } from "vuex"
import "swiper/css/swiper.css"

export default {
  name: "aliBeyBooking",
  components: { Swiper, SwiperSlide },
  directives: { swiper: directive },
  data() {
    return {
      bookingLoading: false,
      userBirthday: null,
      faultyBirthday: false,
      showSnackBar: false,
      adultCount: 0,
      snackBarMessage: "Fehler!",
      aerobicPrice: 119,
      activeBirthDayPicker: "",
      bookingDateRange: ["2026-05-30", "2026-06-06"],
      tshirtSizes: ["XS", "S", "M", "L", "XL", "XXL", "XXXL"],
      rangePicker: false,
      childrenAge: [
        { start: 0, end: 2 },
        { start: 0, end: 6 },
        { start: 0, end: 12 },
        { start: 3, end: 12 },
        { start: 7, end: 12 },
      ],
      form: { persons: [] },
      requiredField: [(v) => !!v || "Dies ist ein Pflichtfeld"],
      standardRooms: [
        {
          title: "Standardzimmer",
          selected: false,
          showEquipment: false,
          img: "/img/einmalig/alibeyStandardRoom.jpg",
          equipment: [
            "26 m2",
            "WLAN",
            "SAT LCD TV",
            "Musikkanäle",
            "Telefon",
            "Minibar",
            "Klimaanlage",
            "Safe",
            "Dusche / WC",
            "Föhn",
            "Keramikboden",
            "Balkon",
            "Ultra All inclusive",
          ],
          possibilities: [
            { adult: 1, children: { count: 0 }, price: 194.0 * 1.05 },
            { adult: 1, children: { count: 1, age: 1 }, price: 194.0 * 1.05 },
            { adult: 1, children: { count: 1, age: 4 }, price: 258.0 * 1.05 },
            { adult: 2, children: { count: 0 }, price: 258.0 * 1.05 },
            { adult: 2, children: { count: 1, age: 0 }, price: 258.0 * 1.05 },
            { adult: 2, children: { count: 1, age: 3 }, price: 350.0 * 1.05 },
            { adult: 3, children: { count: 0 }, price: 350.0 * 1.05 },
          ],
        },
        {
          title: "Standardzimmer",
          subtitle: "Superior",
          selected: false,
          showEquipment: false,
          img: "/img/einmalig/alibeySuperiorStandardRoom.jpg",
          equipment: [
            "26 m2",
            "WLAN",
            "SAT LCD TV",
            "Musikkanäle",
            "Telefon",
            "Minibar",
            "Klimaanlage",
            "Safe",
            "Dusche / WC",
            "Föhn",
            "Marmorboden",
            "Balkon",
            "Ultra All inclusive",
          ],
          possibilities: [
            { adult: 1, children: { count: 0 }, price: 216.0 * 1.05 },
            { adult: 1, children: { count: 1, age: 0 }, price: 216.0 * 1.05 },
            { adult: 1, children: { count: 1, age: 3 }, price: 286.0 * 1.05 },
            { adult: 2, children: { count: 0 }, price: 286.0 * 1.05 },
            { adult: 2, children: { count: 1, age: 0 }, price: 286.0 * 1.05 },
            { adult: 2, children: { count: 1, age: 3 }, price: 356.0 * 1.05 },
            { adult: 3, children: { count: 0 }, price: 356.0 * 1.05 },
          ],
        },
      ],
      familyRooms: [
        {
          title: "Familienzimmer",
          selected: false,
          img: "/img/einmalig/alibeyFamilyRoom.jpg",
          showEquipment: false,
          equipment: [
            "40 m2",
            "WLAN",
            "SAT LCD TV",
            "Musikkanäle",
            "Telefon",
            "Minibar",
            "Klimaanlage",
            "Safe",
            "Dusche / WC",
            "Föhn",
            "Keramikboden",
            "Balkon",
            "Ultra All inclusive",
          ],
          possibilities: [
            { adult: 2, children: { count: 0 }, price: 385.0 * 1.05 },
            { adult: 2, children: { count: 1, age: 2 }, price: 385.0 * 1.05 },
            { adult: 2, children: { count: 2, age: 2 }, price: 385.0 * 1.05 },
            { adult: 3, children: { count: 0 }, price: 385.0 * 1.05 },
            { adult: 3, children: { count: 1, age: 2 }, price: 385.0 * 1.05 },
            { adult: 4, children: { count: 0 }, price: 465.0 * 1.05 },
          ],
        },
        {
          title: "Familienzimmer",
          subtitle: "superior",
          selected: false,
          img: "/img/einmalig/alibeySuperiorFamilyRoom.jpg",
          showEquipment: false,
          equipment: [
            "40 m2",
            "WLAN",
            "SAT LCD TV",
            "Musikkanäle",
            "Telefon",
            "Minibar",
            "Klimaanlage",
            "Safe",
            "Dusche / WC",
            "Föhn",
            "Marmorboden",
            "Balkon",
            "Ultra All inclusive",
          ],
          possibilities: [
            { adult: 2, children: { count: 0 }, price: 459.0 * 1.05 },
            { adult: 2, children: { count: 1, age: 2 }, price: 459.0 * 1.05 },
            { adult: 2, children: { count: 2, age: 2 }, price: 459.0 * 1.05 },
            { adult: 3, children: { count: 0 }, price: 459.0 * 1.05 },
            { adult: 3, children: { count: 1, age: 2 }, price: 459.0 * 1.05 },
            { adult: 4, children: { count: 0 }, price: 559.0 * 1.05 },
          ],
        },
      ],
      filteredRooms: [],
    }
  },
  created() {
    if (this.navigationVisible) this.toggleNavigationBarVisibility()
    this.initialSetup()
  },
  beforeDestroyed() {
    if (!this.navigationVisible) this.toggleNavigationBarVisibility()
  },
  methods: {
    ...mapActions("navigationStoreNotPersisted", ["setNavigationBarText", "toggleNavigationBarVisibility"]),
    initialSetup() {
      api.getUser().then((data) => {
        this.faultyBirthday = false
        if (
          !this.$moment(data.user.geburtstag, "YYYY-MM-DD", true).isValid() ||
          !this.$moment(data.user.geburtstag, "YYYY-MM-DD").isBefore("2010-05-24") ||
          data.user.geburtstag === "--"
        ) {
          this.faultyBirthday = true
          data.user.geburtstag = null
        }
        this.form.persons = []
        this.form.persons.push({
          email: data.user.email,
          firstName: data.user.vorname,
          lastName: data.user.nachname,
          birthDayPicker: { activeMenu: false, date: data.user.geburtstag },
          shirtSize: null,
        })
      })
    },
    exitAlibey() {
      if (!this.navigationVisible) this.toggleNavigationBarVisibility()
      this.$router.push("/alibey")
    },
    saveBirthday() {
      if (this.$moment(this.userBirthday, "YYYY-MM-DD", true).isValid()) {
        api.setUserBirthday(this.userBirthday).then(() => {
          this.initialSetup()
        })
      } else {
        alert("Bitte gebe ein gültiges Geburtsdatum ein")
      }
    },
    formatPrice(x, places = 2, country = "de-CH") {
      return Number(x || 0).toLocaleString(country, { maximumFractionDigits: places, minimumFractionDigits: places })
    },
    scrollToTop() {
      const el = this.$el.querySelector(".swiper-slide-active .slide-content")
      if (el) el.scrollTo({ top: 0, behavior: "smooth" })
    },
    selectRoom(index) {
      this.filteredRooms.forEach((room, i) => {
        room.selected = index === i
      })
    },
    showEquipment(index) {
      this.filteredRooms[index].showEquipment = !this.filteredRooms[index].showEquipment
    },
    deletePerson(index) {
      if (this.form.persons.length > 1) {
        this.form.persons.splice(index, 1)
      } else {
        this.showSnackBarWithMessage("Mindestens eine Person muss bestehen bleiben.")
      }
    },
    formIsValid() {
      return this.$refs.personForm.validate()
    },
    saveDatePicker(date, index) {
      this.$refs["birthDayPicker" + index][0].save(date)
    },
    createBooking() {
      this.bookingLoading = true
      // Nur die benötigten Daten in ein sauberes Objekt packen
      const bookingData = {
        adults: this.adultCount,
        form: this.form,
        duration: this.duration,
        dateRange: this.bookingDateRange,
        room: this.selectedRoom,
      }

      const newListEntry = {
        category: "alibey",
        content: bookingData, // Nur das saubere Datenobjekt übergeben
      }

      api
        .createListEntry(newListEntry)
        .then(() => {
          alert("Deine Buchung wurde gespeichert. Die Rechnung werden wir Dir in den nächsten Tagen zustellen. Wir freuen uns auf Dich.")
          this.$router.push({ name: "Home" })
        })
        .finally(() => {
          this.bookingLoading = false
        })
    },
    showSnackBarWithMessage(message) {
      this.snackBarMessage = message
      this.showSnackBar = true
    },
    addNewPerson() {
      if (this.form.persons.length >= 4) {
        this.showSnackBarWithMessage("Maximal 4 Personen pro Buchung.")
      } else {
        this.form.persons.push({ firstName: null, lastName: null, birthDayPicker: { activeMenu: false, date: null }, shirtSize: null })
      }
    },
    setPickerToYear(index) {
      if (this.form.persons[index]) {
        setTimeout(() => (this.activeBirthDayPicker = "YEAR"), 50)
      }
    },
    slideToSelection() {
      if (this.$moment(this.bookingDateRange[1]).isBefore(this.$moment(this.bookingDateRange[0]))) {
        return this.showSnackBarWithMessage("Das End-Datum kann nicht vor dem Start-Datum liegen.")
      }
      if (this.formIsValid()) {
        this.calculateOptions()
        this.slideTo(1)

        // Hinzugefügter Code, um den Scroll auf der nächsten Seite zurückzusetzen
        this.$nextTick(() => {
          this.scrollToTop()
        })
      } else {
        this.showSnackBarWithMessage("Bitte fülle alle Pflichtfelder korrekt aus.")
      }
    },
    confirmRoom() {
      if (this.selectedRoom) {
        this.slideTo(2)
        this.scrollToTop()
      }
    },
    calculateOptions() {
      this.filteredRooms = []
      let adults = 0,
        children = { count: 0, age: null }
      this.form.persons.forEach((p) => {
        const age = this.$moment(this.bookingDateRange[0]).diff(p.birthDayPicker.date, "years")
        if (age > 12) adults++
        else {
          children.count++
          children.age = age
        }
      })
      if (this.form.persons.length <= 3) {
        this.standardRooms.forEach((room) => {
          const poss = room.possibilities.find(
            (p) =>
              p.adult === adults &&
              children.count === p.children.count &&
              (children.count !== 1 ||
                (this.childrenAge[p.children.age].start <= children.age && this.childrenAge[p.children.age].end >= children.age))
          )
          if (poss) this.filteredRooms.push({ ...room, possibility: poss })
        })
      }
      if (this.form.persons.length >= 2) {
        this.familyRooms.forEach((room) => {
          const poss = room.possibilities.find((p) => p.adult === adults && p.children.count === children.count)
          if (poss) this.filteredRooms.push({ ...room, possibility: poss })
        })
      }
      this.adultCount = adults
    },
    slideTo(slide) {
      this.$refs.aliBeySwiper.$swiper.slideTo(slide, 500, false)
    },
  },
  computed: {
    ...mapState("navigationStoreNotPersisted", ["navigationVisible"]),
    formattedBookingDateRange() {
      if (!this.bookingDateRange || this.bookingDateRange.length < 2) return ""
      const [start, end] = this.bookingDateRange.map((d) => this.$moment(d).format("DD.MM.YY"))
      return `${start} - ${end}`
    },
    duration() {
      return this.$moment(this.bookingDateRange[1]).diff(this.$moment(this.bookingDateRange[0]), "days")
    },
    selectedRoom() {
      return this.filteredRooms.find((room) => room.selected)
    },
    aliBeySwiperOptions() {
      return { allowTouchMove: false, pagination: { el: ".swiper-pagination", dynamicBullets: true } }
    },
  },
}
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@400;700;900&display=swap");

.booking-container-light {
  height: 100vh;
  width: 100vw;
  background-color: #f7f9fc;
  font-family: "Poppins", sans-serif;
  color: var(--v-alibey);
}

.booking-swiper,
.booking-slide {
  height: 100%;
  width: 100%;
}

.slide-content {
  width: 100%;
  height: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  overflow-y: auto; /* Diese Zeile ist der Fix für das Scroll-Problem */
}

.slide-title {
  font-size: 2rem;
  font-weight: 900;
  text-align: center;
  margin-bottom: 2rem;
  margin-top: 2rem;
  line-height: 1.2;
  color: var(--v-alibey);
}

.person-form,
.person-cards-container {
  flex-shrink: 0;
}

.person-card {
  background-color: #ffffff;
  border-color: #e0e0e0;
  margin-bottom: 1rem;
  .person-card-title {
    font-weight: 700;
  }
}

.add-person-btn {
  width: 100%;
  padding: 20px 0;
}

/* FIX FÜR SCROLL-VERHALTEN */
.room-selection-container {
  flex: 1 1 auto; /* Erlaubt dem Container zu wachsen/schrumpfen */
  overflow-y: auto; /* Fügt Scrollbar hinzu, wenn Inhalt überläuft */
  padding: 1rem;
  margin: 0 -1rem; /* Negativer Margin, um Padding auszugleichen */
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1rem;
  align-content: flex-start;
}

.room-card {
  border-radius: 16px;
  border-color: #e0e0e0;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  background-color: #ffffff !important;
  display: flex;
  flex-direction: column;

  &:hover {
    transform: translateY(-5px);
    border-color: var(--v-primary-base);
  }

  &.selected-glow {
    border-color: var(--v-primary-base);
    box-shadow: 0 4px 20px rgba(var(--v-primary-base), 0.3);
  }

  .room-title {
    font-size: 1.2rem;
    font-weight: 700;
    line-height: 1.3;
    word-break: break-word;
  }
  .price-total {
    display: block;
    font-size: 1.5rem;
    font-weight: 900;
    color: var(--v-primary-base);
  }
  .price-per-day,
  .price-info {
    display: block;
    font-size: 0.9rem;
    opacity: 0.8;
  }

  .equipment-grid {
    padding: 16px;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    background-color: #f7f9fc;
  }
  .equipment-chip {
    background-color: #e8eaf6 !important;
    color: var(--v-alibey);
    font-weight: 600;
  }

  .room-actions {
    justify-content: center;
  }
}

.confirmation-card {
  background-color: #ffffff;
  border-color: #e0e0e0;
  border-radius: 20px;
  padding-bottom: 20px;

  .confirmation-title {
    font-size: 1.5rem;
    font-weight: 700;
    word-break: break-word;
  }
  .total-price-label {
    font-size: 1rem;
    opacity: 0.8;
  }
  .total-price-value {
    font-size: 2.5rem;
    font-weight: 900;
    color: var(--v-primary-base);
    line-height: 1.1;
  }
  .price-info {
    opacity: 0.7;
  }
}

.slide-actions {
  padding: 1rem 0;
  margin-top: auto;
  flex-shrink: 0;
  justify-content: space-between;

  .next-step-btn {
    font-weight: 700;
    animation: pulse 2s infinite;
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.03);
  }
  100% {
    transform: scale(1);
  }
}

::v-deep .swiper-pagination-bullet {
  background: var(--v-alibey);
  opacity: 0.3;
}
::v-deep .swiper-pagination-bullet-active {
  opacity: 1;
}
</style>
